

import Vue from 'vue'
import states from '../helpers/states'
import format from 'date-fns/format'

export default Vue.extend({
    props: {
        state: {
            type: Object,
            default: () => ({})
        },
        props: {
            type: Object,
            default: () => ({})
        },
        listId: {
            type: String
        }
    },
    computed: <any>{
        stateDef() {
            return states[this.state.key]
        },
        dateFormatted() {
            return format(this.state.date, 'YYYY-MM-DD')
        }
    }
})
